import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RiaLogin } from './models/RiaLogin';
import { BOWIUser } from './models/BowiUser';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {


  constructor(private userService: UserService) { }

  public compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  public isEmptyOrUndefined(value) {
    return value === undefined || value === null || value.toString() === '';
  }

  public formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  formatPrice(price: any) {
    if (price === null || price === undefined || price === '') {
      return price;
    }

    let num = price.split('.');
    if (num.length === 1)// no decimal  places , we add them
    {
      price = price + ".00";
    }
    else {
      var decimals = num[1];
      decimals = this.removeTrailingZeros(decimals);

      if (decimals.length === 0) //e.g. 50 , we want 50.00
        return num[0] + ".00";

      if (decimals.length === 1) //e.g. 50.1 , we want 50.10
        return num[0] + '.' + decimals + "0";

      // we can show something like 50.0001234
      return num[0] + '.' + decimals;

    }

    return price;
  }

  formatQuantity(quantity: any) {
    if (quantity === null || quantity === undefined || quantity === '') {
      return quantity;
    }
    let newQuantity = quantity.split('.');


    if (newQuantity.length === 1)// no decimal  places , we add them
    {
      quantity = quantity + ".00";

    }

    let num = quantity.split('.');
    var decimals = num[1];
    decimals = this.removeTrailingZeros(decimals);

    if (decimals === "")
      return num[0];

    return num[0] + '.' + decimals;

  }


  removeTrailingZeros(decimals: string) {
    var len = decimals.length - 1;
    let traligZerosCount = 0;
    for (var _i = len; _i >= 0; --_i) {
      if (decimals[_i] !== '0')
        break;

      traligZerosCount++;
    }

    return decimals.substring(0, decimals.length - traligZerosCount);

  }


  encode(s: string): string {
    let result = '';
    for (let i = 0; i < s.length; i++) {
      let ch = s.charAt(i);
      let hex = ch.charCodeAt(0).toString(16);
      result += hex.slice(-1) + hex.slice(0, 1);
    }
    result = result.slice(result.length / 2) + result.slice(0, result.length / 2);
    return result;
  }

  fetchBrokerUserDetails(brokerId: number): Observable<BOWIUser> {
    return this.userService.GetBowiUser(brokerId)
      .pipe(
        map((users: BOWIUser[]) => {
          return users[0];
        })
      );
  }

  fetchClientUserDetails(clientId: number): Observable<RiaLogin> {
    return this.userService.GetRiaLogin(clientId)
      .pipe(
        map((users: RiaLogin[]) => {
          return users[0];
        })
      );
  }
}